/**
 * Trader API V2
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
export var EdrBalanceResponseV2;
(function (EdrBalanceResponseV2) {
    EdrBalanceResponseV2.AccountStatusEnum = {
        Pending: 'Pending',
        Active: 'Active',
        Frozen: 'Frozen',
        Deceased: 'Deceased',
        Banned: 'Banned',
        Deactivated: 'Deactivated',
        Archived: 'Archived'
    };
    EdrBalanceResponseV2.RedemptionPreferenceEnum = {
        SpendNow: 'SpendNow',
        SaveForOccasion: 'SaveForOccasion',
        AirNZ: 'AirNZ',
        Qantas: 'Qantas'
    };
})(EdrBalanceResponseV2 || (EdrBalanceResponseV2 = {}));
